export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13824.3f536994.jpg";